export enum CamposParcelasComercialEnum {
  x12 = 12,
  x24 = 24,
  x36 = 36,
  x48 = 48,
  x72 = 72
}
